import React from 'react';

import styles from './onboarding.module.css';

// Карточка-подсказка: заголовок, текст, счётчик шагов и кнопки.
// Ничего не считает и не ищет на странице — всё приходит сверху, поэтому её
// легко проверить тестом и показать отдельно.

const TourCard = React.forwardRef(
  ({ title, text, stepNumber, total, ui, position, centered, isLast, isFirst, onNext, onBack, onSkip }, ref) => (
    <div
      ref={ref}
      className={`${styles.card} ${centered ? styles.cardCentered : ''}`}
      style={centered ? undefined : position}
      role="dialog"
      aria-modal="true"
      aria-labelledby="onboarding-card-title"
      tabIndex={-1}
    >
      <h2 className={styles.title} id="onboarding-card-title">
        {title}
      </h2>
      <p className={styles.text}>{text}</p>

      <div className={styles.footer}>
        <span className={styles.counter}>{ui.stepOf(stepNumber, total)}</span>

        <div className={styles.actions}>
          <button type="button" className={styles.skip} onClick={onSkip}>
            {ui.skip}
          </button>
          {!isFirst && (
            <button type="button" className={`${styles.button} ${styles.secondary}`} onClick={onBack}>
              {ui.back}
            </button>
          )}
          <button type="button" className={`${styles.button} ${styles.primary}`} onClick={onNext} autoFocus>
            {isLast ? ui.finish : ui.next}
          </button>
        </div>
      </div>
    </div>
  )
);

TourCard.displayName = 'TourCard';

export default TourCard;
